import { ArrowUpDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';

interface FilterableTableHeadProps {
  title: string;
  filterType: 'select' | 'sort' | 'none';
  value?: string;
  onValueChange?: (value: string) => void;
  options?: { value: string; label: string }[];
  className?: string;
  hasActiveFilter?: boolean;
}

const triggerClassName =
  'h-auto min-h-0 border-none bg-transparent p-0 text-[11px] font-semibold uppercase tracking-[0.14em] text-[hsl(var(--app-text-muted))] shadow-none hover:text-[hsl(var(--app-text-strong))] [&>svg]:hidden';

export const FilterableTableHead = ({
  title,
  filterType,
  value,
  onValueChange,
  options,
  className,
  hasActiveFilter = false,
}: FilterableTableHeadProps) => {
  if (filterType === 'none') {
    return (
      <TableHead className={className}>
        <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[hsl(var(--app-text-muted))]">
          {title}
        </div>
      </TableHead>
    );
  }

  if (filterType === 'sort') {
    return (
      <TableHead className={className}>
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger className={triggerClassName}>
            <div className="flex items-center gap-1.5">
              <span>{title}</span>
              <ArrowUpDown className="h-3.5 w-3.5" />
              {hasActiveFilter && (
                <div className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--app-accent))]" />
              )}
            </div>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Aucun tri</SelectItem>
            <SelectItem value="asc">Tri croissant</SelectItem>
            <SelectItem value="desc">Tri décroissant</SelectItem>
          </SelectContent>
        </Select>
      </TableHead>
    );
  }

  return (
    <TableHead className={className}>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className={triggerClassName}>
          <div className="flex items-center gap-1.5">
            <span>{title}</span>
            <ArrowUpDown className="h-3.5 w-3.5" />
            {hasActiveFilter && (
              <div className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--app-accent))]" />
            )}
          </div>
        </SelectTrigger>
        <SelectContent>
          {options?.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </TableHead>
  );
};
